import { defineMessages, type MessageValue } from 'react-intl';

export const lineItemIngredientsMessages = defineMessages<{
  readonly addedIngredients: { readonly ingredients: MessageValue };
  readonly removedIngredients: { readonly ingredients: MessageValue };
}>({
  addedIngredients: {
    defaultMessage: 'Added: {ingredients}',
    description: 'Lite item | Ingredients | Added ingredients',
  },
  removedIngredients: {
    defaultMessage: 'Removed: {ingredients}',
    description: 'Lite item | Ingredients | Removed ingredients',
  },
});
